import { memo } from 'react';
import PropTypes from 'prop-types';
import ButtonCTA from '@/components/component-library/Button/CTA';
import PlayPauseCTA from '@/components/component-library/Button/PlayPauseCTA';
import Text, { FONT_SIZE_140 } from '@/components/component-library/Text';
import GenreBadges from '@/components/component-library/GenreBadges';
import LayoutWrapperHorizontal from '@/components/component-library/LayoutWrapperHorizontal';
import BadgeNew from '@/components/component-library/BadgeNew';

const SlateInformation = ({
  loading,
  loadingPlayButton,
  hidePlayButton,
  title,
  genres,
  onClickPlay,
  onClickInfo,
  showHref,
  isPaused,
  seasonNumber,
  episodeNumber,
  isCurrentlyPlayingShow,
  releaseDate
}) => {
  const showPlayButton = onClickPlay && !hidePlayButton;

  return (
    <LayoutWrapperHorizontal className='slate-info'>
      <Text bold className='title' loading={loading} size={FONT_SIZE_140}>
        {title}
      </Text>
      {releaseDate && <BadgeNew />}
      <div className='slate-info-summary'>
        <GenreBadges enableLinks genres={genres} loading={loading} />
      </div>
      <div className='slate-info-buttons-mobile'>
        {showPlayButton && (
          <PlayPauseCTA
            disabled={loadingPlayButton}
            episodeNumber={episodeNumber}
            isCurrentlyPlayingShow={isCurrentlyPlayingShow}
            loading={loadingPlayButton}
            onClick={onClickPlay}
            paused={isPaused}
            seasonNumber={seasonNumber}
          />
        )}
        {onClickInfo && (
          <ButtonCTA
            className='slate-information-more-info-button'
            href={showHref}
            loading={loading}
            onClick={onClickInfo}
          >
            More Info
          </ButtonCTA>
        )}
      </div>
    </LayoutWrapperHorizontal>
  );
};

SlateInformation.propTypes = {
  loading: PropTypes.bool,
  loadingPlayButton: PropTypes.bool,
  title: PropTypes.string,
  genres: PropTypes.arrayOf(PropTypes.object),
  onClickPlay: PropTypes.func.isRequired,
  hidePlayButton: PropTypes.bool,
  onClickInfo: PropTypes.func,
  showHref: PropTypes.string,
  isPaused: PropTypes.bool,
  seasonNumber: PropTypes.number,
  episodeNumber: PropTypes.number,
  isCurrentlyPlayingShow: PropTypes.bool,
  releaseDate: PropTypes.string
};

SlateInformation.defaultProps = {
  loading: false,
  loadingPlayButton: false,
  title: '',
  genres: [],
  onClickInfo: undefined,
  hidePlayButton: false,
  isPaused: false,
  seasonNumber: null,
  episodeNumber: null,
  isCurrentlyPlayingShow: false,
  showHref: '',
  releaseDate: undefined
};

export default memo(SlateInformation);
